import { render } from "./Dots.vue?vue&type=template&id=1d5f2950"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Dots.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d5f2950"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d5f2950', __exports__)) {
    api.reload('1d5f2950', __exports__)
  }
  
  module.hot.accept("./Dots.vue?vue&type=template&id=1d5f2950", () => {
    api.rerender('1d5f2950', render)
  })

}


export default __exports__